<div *ngIf="isLost">

</div>

<div *ngIf="stageLights$ | async as stageLights">
  <div *ngIf="stageLights" class="stage-lights">
    <div *ngFor="let stageLight of stageLights" class="stage-light-col" [ngClass]="{'active': stageLight.active}">

      <div class="stage-light-wrap">
        <div class="stage-light">
        </div>
      </div>

    </div>
  </div>
</div>
